document.addEventListener("DOMContentLoaded", () => {
    initBreadcrumbsScroll();
});

const initBreadcrumbsScroll = () => {
    const breadcrumbs = document.querySelector('.breadcrumbs');
    breadcrumbs.scrollLeft = breadcrumbs.scrollWidth;
};

document.addEventListener('DOMContentLoaded', () => {
    const menuItems = document.querySelectorAll('.help__menu-list a');
    const sections = Array.from(menuItems).map(item => document.querySelector(item.getAttribute('href')));

    menuItems.forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 100,
                    behavior: 'smooth'
                });
            }
        });
    });

    window.addEventListener('scroll', () => {
        let current = '';

        sections.forEach((section, index) => {
            const sectionTop = section.offsetTop - 141;
            const sectionHeight = section.clientHeight;
            const nextSectionTop = sections[index + 1] ? sections[index + 1].offsetTop - 141 : Infinity;

            if (pageYOffset >= sectionTop && pageYOffset < nextSectionTop) {
                current = section.getAttribute('id');
            }
        });

        menuItems.forEach(anchor => {
            anchor.parentElement.classList.remove('active');
            if (anchor.getAttribute('href').substring(1) === current) {
                anchor.parentElement.classList.add('active');
            }
        });
    });
});